import React from "react";
import MenuItem from "@mui/material/MenuItem";
import {
  useGridApiContext,
  gridVisibleColumnDefinitionsSelector,
  gridFilteredSortedRowIdsSelector,
} from "@mui/x-data-grid-premium";
import { exportGridToPdf } from "../../util/gridPdfExport";
import { generateFileUrl } from "../../requestMethods";

// Itens "PDF" para o menu Exportar do DataGridPremium (GridToolbarExportContainer
// injeta hideMenu). Usa todas as linhas filtradas/ordenadas — não só a página —
// e só as colunas visíveis, com o valor já formatado pelo valueFormatter da coluna.
export default function GridPdfExportMenuItems({ hideMenu, title }) {
  const apiRef = useGridApiContext();

  const exportPdf = async (orientation) => {
    const colDefs = gridVisibleColumnDefinitionsSelector(apiRef);
    const rows = gridFilteredSortedRowIdsSelector(apiRef)
      .map((id) => apiRef.current.getRow(id))
      .filter(Boolean);
    const columns = colDefs.map((colDef) => ({
      field: colDef.field,
      headerName: colDef.headerName,
      type: colDef.type,
      getValue: (row) => apiRef.current.getRowFormattedValue(row, colDef),
      // Foto: o caminho cru, não o texto formatado.
      getRawValue: (row) => row[colDef.field],
    }));
    hideMenu?.();
    await exportGridToPdf({ columns, rows, orientation, title, resolveImageUrl: generateFileUrl });
  };

  return (
    <>
      <MenuItem onClick={() => exportPdf("portrait")}>PDF vertical</MenuItem>
      <MenuItem onClick={() => exportPdf("landscape")}>PDF horizontal</MenuItem>
    </>
  );
}
